import { IonButton, IonCol, IonRow } from '@ionic/react';
import { DqText } from '../../components/dq-text';
import { JobReportGuestAuthMessages } from '../../intl/JobReportGuestAuthMessages';
import React, { FC, useCallback } from 'react';
import { Amplify, Auth } from 'aws-amplify';
import { config } from '../../amplify-config';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';

export const NotGuestComponent: FC = () => {
  const { formatMessage } = useIntl();
  const history = useHistory();

  const reconfigureAmplifyAndRedirect = useCallback(async () => {
    // Amplify is configured for guest access when the URL is /job-report-share/:id. Since we want to send the user to
    // the Cognito-hosted auth flow, we need to reconfigure Amplify.
    Amplify.configure(config);

    // Just in case we were signed in as guest
    await Auth.signOut();

    // Navigating to '/welcome' will cause the Cognito-hosted sign in prompt to display.
    history.push('/welcome');
  }, [history]);

  return (
    <>
      <IonRow className="guest-sign-in-button">
        <DqText variant="h3" color="dark">
          {formatMessage(JobReportGuestAuthMessages.notAGuest)}
        </DqText>
      </IonRow>
      <IonRow>
        <DqText className="ion-margin-vertical" variant="body" color="dark">
          {formatMessage(JobReportGuestAuthMessages.fullExperience)}
        </DqText>
      </IonRow>
      <IonRow>
        <IonCol className="ion-no-padding ion-margin-vertical">
          <IonButton onClick={reconfigureAmplifyAndRedirect} fill="outline" color="dark">
            {formatMessage(JobReportGuestAuthMessages.signInNow)}
          </IonButton>
        </IonCol>
      </IonRow>
    </>
  );
};
